module.exports = __webpack_public_path__ + "img/simpsonator.d9e29e05.jpg";